(() => {
  'use strict';
  const widget = document.querySelector('[data-trisoria-concierge]');
  if (!widget || widget.dataset.initialized === 'true') return;
  widget.dataset.initialized = 'true';
  const toggle = widget.querySelector('[data-tsc-toggle]');
  const close = widget.querySelector('[data-tsc-close]');
  const panel = widget.querySelector('.tsc__panel');
  const start = widget.querySelector('[data-tsc-start]');
  const status = widget.querySelector('[data-tsc-status]');
  if (!toggle || !close || !panel) return;
  let previouslyFocused = null;
  const setOpen = (open, restoreFocus = true) => {
    if (open) previouslyFocused = document.activeElement;
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    if (open) close.focus();
    else if (restoreFocus && previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus();
  };
  toggle.addEventListener('click', () => setOpen(panel.hidden));
  close.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !panel.hidden) setOpen(false);
  });
  document.addEventListener('pointerdown', event => {
    if (!panel.hidden && !widget.contains(event.target)) setOpen(false, false);
  });
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-concierge]');
    if (!opener) return;
    event.preventDefault();
    if (panel.hidden) setOpen(true);
    else close.focus();
  });
  if (widget.querySelector('[data-tsc-success], [data-tsc-error]')) setOpen(true);
  if (!start) return;
  const id = widget.dataset.crispId || '';
  const validId = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
  if (!validId) {
    start.disabled = true;
    if (status) status.textContent = widget.dataset.chatMissing || 'Live chat is not configured. Please send an enquiry.';
    return;
  }
  let loading = false;
  let loaded = false;
  const openCrisp = () => {
    window.$crisp = window.$crisp || [];
    window.$crisp.push(['do', 'chat:show']);
    window.$crisp.push(['do', 'chat:open']);
    setOpen(false, false);
  };
  start.addEventListener('click', () => {
    if (loaded) { openCrisp(); return; }
    if (loading) return;
    loading = true;
    start.disabled = true;
    if (status) status.textContent = widget.dataset.chatConnecting || 'Connecting to live chat…';
    window.$crisp = window.$crisp || [];
    window.CRISP_WEBSITE_ID = id;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://client.crisp.chat/l.js';
    const fail = () => {
      loading = false;
      start.disabled = false;
      if (status) status.textContent = widget.dataset.chatError || 'Unable to connect. Please send an enquiry.';
    };
    const timer = window.setTimeout(fail, 12000);
    script.onload = () => {
      window.clearTimeout(timer);
      loading = false;
      loaded = true;
      start.disabled = false;
      if (status) status.textContent = '';
      openCrisp();
    };
    script.onerror = () => { window.clearTimeout(timer); fail(); };
    document.head.appendChild(script);
  });
})();
